import { render } from "./ServerErrorView.vue?vue&type=template&id=5cf412d8&scoped=true"
const script = {}

import "./ServerErrorView.vue?vue&type=style&index=0&id=5cf412d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf412d8"]])

export default __exports__